<template>
    <div class="l-content__block p-index__recommend" v-show="showHistory">
        <div class="c-block__headings">
            <h2 class="" v-html="h2_label"></h2>
        </div>
        <div class="c-slider-wrapper swiper-container-recommend">
            <div class="c-slider-normal swiper-wrapper">
                <div class="c-slider-normal__item swiper-slide" v-for="recommend in recommends">
                    <a :href="recommend.url" :data-recommend_type="stripHtml(h2_label)" :data-recommend_model="getTalentNames(recommend.talents)" :data-recommend_title="recommend.title" :data-recommend_from="getCurrentPath()" :data-recommend_content_type="getCategoryName(recommend.category)">
                        <div class="c-slider-normal__img">
                            <webp-picture :webp="recommend.thumb_nail_webp" class="inherit">
                                <img alt="" loading="lazy"
                                    :src="recommend.thumb_nail">
                            </webp-picture>
                        </div>
                        <p class="c-bookname text-truncate2">{{ getTalentNames(recommend.talents) }}</p>
                        <span class="c-booktitle text-truncate2">{{recommend.title}}</span>
                        <div class="c-slider-normal__icon">
                            <div class="c-label-new" v-if="recommend.new">New</div>
                            <div :class="getCategoryClass(recommend.category)">{{ getCategoryName(recommend.category) }}</div>
                        </div>
                    </a>
                    <div class="c-btn-trial" v-if="show_cart_button && recommend.item_detail_url && isSaleStarted(recommend)"><a :href="getAddCartUrl(recommend)" tabindex="0">{{getCartButtonString(recommend)}}</a></div>
                    <div class="c-btn-trial" v-if="recommend.has_sample"><a :href="getSampleUrl(recommend.item_detail_url)" target="_blank">立ち読み</a></div>
                </div>
            </div>
            <img src="/src/assets/img/common/slider-arrow-prev.png" alt="＜" class="slide-arrow prev-arrow swiper-button-disabled" tabindex="-1" role="button">
            <img src="/src/assets/img/common/slider-arrow-next.png" alt="＞" class="slide-arrow next-arrow" tabindex="0" role="button">
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
    </div>
</template>

<script>
import routeMixin from '../mixins/route.js';
import moment from "moment";
import axios from 'axios';
import Swiper from 'swiper/bundle';
export default {
    props: {
        route_list: Object,
        recommend_categories: Array,
        recommend_from : String,
        recommender_string: String,
        number_of_result: {
            type: [String, Number],
        },
        h2_label: String,
        show_cart_button: false,
    },
    mixins: [routeMixin],
    data() {
        return {
            recommends: []
        }
    },
    methods: {
        stripHtml: function(value) {
            if (!value) return '';
            const element = document.createElement('div');
            element.innerHTML = value;
            return element.textContent || '';
        },
        getData: async function(){
            let url = this.route(this.route_list, 'site.api.recommender');
            let recommends = [];
            // number_of_resultを数値に変換
            let number_of_result = Number(this.number_of_result);
            let params = {
                params: {
                    recommend_from : this.recommend_from,
                    recommender_string : this.recommender_string,
                    number_of_result : number_of_result,
                    recommend_categories : this.recommend_categories,
                }
            }

            let fall_back_param = {
                params: {
                    recommender_string : 'mostviewed',
                    number_of_result : number_of_result,
                    recommend_categories : this.recommend_categories,
                }
            }
            if (!this.recommend_from) {
                params = fall_back_param
            }
            if (this.show_cart_button) {
                params['params']['add_cart_condition'] = true;
            }

            let done = false;
            await axios.get(url, params)
            .then(res => {
                recommends = res.data;
                done = true;
            }).catch(error => {

            });

            if (done && recommends.length === 0) {
                await axios.get(url, fall_back_param
                ).then(res => {
                    recommends = res.data;
                }).catch(error => {

                });
            }

            return recommends;
        },
        makeData: async function(){
            let recommends = await this.getData();
            if (!Array.isArray(recommends)) {
                recommends = [];
            }
            // Newフラグの付与を行う
            recommends.forEach(function(recommend){
                recommend.new = false;
                let dateField = recommend.sale_start_date || recommend.pub_date;
                if(dateField !== null) {
                    let startDate = moment(dateField);
                    let lastDate = moment().subtract(7, 'days').startOf('days');
                    if(startDate.isAfter(lastDate)) {
                        recommend.new = true;
                    }
                }
            });
            this.recommends = recommends;
        },
        getCategoryName: function(category) {
            let name = '';
            switch(category) {
                case 'GRV':
                    name = '写真集'
                    break
                case 'WPB':
                    name = '週プレ'
                    break
                case 'column':
                    name = 'コラム'
                    break
                case 'special':
                    name = '＋Special'
                    break
                case 'weekly':
                    name = '＋Weekly'
                    break
                case 'dvd':
                    name = '＋付録DVD'
                    break
            }
            return name;
        },
        getCategoryClass: function(category) {
            let className = 'c-label-photobook';
            switch(category) {
                case 'column':
                case 'special':
                case 'weekly':
                case 'dvd':
                    className = 'c-label-photobook c-label-plus'
                        break
            }
            return className;
        },
        getTalentNames: function(talents) {
            return talents.map((talent) => talent).join('、');
        },
        getAddCartUrl: function(item) {
            if (item['in_cart']) {
                return this.route(this.route_list, 'site.item.cart');
            }
            return this.route(this.route_list, 'site.cart.add', {id: item['item_detail_url']});
        },
        getSampleUrl: function(hash) {
            return this.route(this.route_list, 'site.item.sample', {item_detail_url: hash})
        },
        getCartButtonString: function(item) {
            if (item['in_cart']) {
                return 'カートを見る'
            } else {
                return '買い物かごに追加'
            }
        },
        isSaleStarted: function(item) {
            let dateField = item.sale_start_date || item.pub_date;
            if (!dateField) return true;
            return moment(dateField).isSameOrBefore(moment());
        },
        getCurrentPath: function() {
            const url = new URL(location.href);
            url.search = '';
            return url.toString();
        }
    },
    computed: {
        showHistory: function() {
            return this.recommends.length > 0;
        }
    },
    async mounted() {
        await this.makeData();

        // データを読み込んでからSwiperする必要があるのでここで再宣言。
        const swiper = new Swiper('.swiper-container-recommend', {
            slidesPerView: 2.5,
            freeMode: {
                enabled: true,
                momentumBounce: true,
            },
            breakpoints: {
                767: {
                    slidesPerView: 4,
                    navigation: {
                        nextEl: ".next-arrow",
                        prevEl: ".prev-arrow",
                    },
                },
            }
        });
    }
}
</script>

<style scoped>
    .swiper-container-recommend {
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
    }
    .swiper-slide .c-btn-trial:nth-child(n+3) {
        margin-top: 8px;
    }

    .text-truncate2 {
        min-height: 2.72em
    }

    .c-booktitle {
        word-break: break-all;
    }
</style>
